import { useMemo } from "react";
import { getManifestLiveVariation } from "utils/mapStateToProps";
import { useCtxReferences, useProductsPrices } from "utils/selectors";
import { useManifestUniqPrimaries } from "utils/hooks/manifest";
import { useFormikContext } from "formik";
import { useAppUrlVariations } from "./application";
import { getLiveManifestResourceUrl } from "utils/manifest";
import { getAppPageRouteOptions } from "utils/application";
import isEmpty from "lodash/isEmpty";
import { FORM_KEY } from "utils/constants/form";
import { APP_PUBLISH_INTENT } from "utils/constants/application";
import { getProductPrimariesRouteSuggestions } from "utils/publish";

export const usePublishLocationInitialValues = () => {
  const { values } = useFormikContext();

  const { application } = useCtxReferences();
  const manifest = values.manifest;
  const manifestLiveVariation = getManifestLiveVariation({
    id: manifest && manifest.id,
    application
  });
  const urlVariations = useAppUrlVariations();
  let existingRoute = "";
  if (manifestLiveVariation && manifestLiveVariation.route) {
    existingRoute = manifestLiveVariation.route;
  }

  const primaries = useManifestUniqPrimaries();
  const { products } = useProductsPrices();

  /**
   * Generate a list of routes from set of products in checkout
   */
  const routeSuggestions = useMemo(
    () =>
      getProductPrimariesRouteSuggestions({
        products,
        primaries
      }),
    []
  );

  const liveUrl = getLiveManifestResourceUrl({
    application,
    urlVariations,
    liveVariation: manifestLiveVariation
  });
  const pageTargets = getAppPageRouteOptions(application);
  const existingRoutes = pageTargets.reduce((memo, { route }) => {
    memo[route] = true;
    return memo;
  }, {});

  /**
   * If there are no existing routes then we default to adding a new one
   * Else we default to choosing an alternative pre-existing route
   */
  const intent = isEmpty(existingRoutes)
    ? APP_PUBLISH_INTENT.NEW
    : APP_PUBLISH_INTENT.EXISTING;

  return {
    [FORM_KEY]: {
      existingRoutes,
      manifestLiveVariation,
      liveUrl,
      routeSuggestions
    },
    intent,
    newRoute: "",
    existingRoute: existingRoute
  };
};
